module.exports = __webpack_public_path__ + "static/images/search-xl.19fe890.png";